import {PURGE} from 'redux-persist';
import {actions as A} from '../../../constants/actions';

const defaultState = {
  showGlobalMessage: false,
  type: 'warning',
  message: '',
};

export default (state = defaultState, {type, payload}) => {
  switch(type) {
    case A.SHOW_GLOBAL_MESSAGE:
      const {type, message} = payload;
      return {...state, showGlobalMessage: true, type, message};

    case A.HIDE_GLOBAL_MESSAGE:
    case PURGE:
      return {...state, showGlobalMessage: false, type: 'warning', message: ''};

    default:
      return state;
  }
}
